import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import NotFound from './NotFound/NotFound';
import PurchaserRoot from "./purchaser/PurchaserRoot";
import ContractorRoot from "./contractor/ContractorRoot";

function Router() {

    return (
        <Switch>
            <Route exact path={RouterPath.BASE}>
                <Redirect to={RouterPath.MY_PROCEDURE}/>
            </Route>
            <Route path={RouterPath.BUYER_INIT} component={PurchaserRoot}/>
            <Route path={RouterPath.CTR_INIT} component={ContractorRoot}/>
            <Route path={RouterPath.PURCHASER_INIT} component={PurchaserRoot}/>
            <Route component={NotFound}/>
        </Switch>
    )
}

export default Router;
